import {ArticleList} from '../article-list/article-list.comp';
import * as React from 'react';
// import {normalizeCategory} from '../../../common/utils';
import { Article, HomepageComponent, HomepageComponentTypes } from '@wix/answers-api';
import { CategoryList } from '../category-list/category-list.comp';
import { BaseWidgetProps } from '../../widget-container';
import {EventType} from '../../../common/logger/event-type';
// import {translate} from '../../../common/translate';
import { WidgetMessage, WidgetMessageType } from '../../../common/message-types';
import { sanitizeExceptWidgetSdk } from '@wix/answers-widget-viewer';

export type HomPageCompProps = {
	articles: Article[];
	baseConfig: BaseWidgetProps;
	children?: any;
};

type HomPageCompState = {
	homepageComponents: HomepageComponent[];
	customHomePage?: string;
};

export class HomePageComp extends React.Component<HomPageCompProps, any> {
	state: HomPageCompState = {
		homepageComponents: [],
		customHomePage: this.props.baseConfig.messageHistory.getCustomHomePage()
			? sanitizeExceptWidgetSdk(this.props.baseConfig.messageHistory.getCustomHomePage() || '')
			: ''
	};

	constructor (props: HomPageCompProps) {
		super(props);
	}

	componentDidMount () {
		if (window) {
			window.addEventListener('message', this.handleSettingsPostMessage.bind(this));
		}
		this.props.baseConfig.logger.logEvent(EventType.KB_HOME_VIEW, {});
	}

	componentWillUnmount () {
		if (window) {
			window.removeEventListener('message', this.handleSettingsPostMessage.bind(this));
		}
	}

	handleSettingsPostMessage (event: any) {
		const newSettings: any = event.data.previewNewSettings;
		if (newSettings) {
			const homepageComponents = newSettings.kbModule && newSettings.kbModule.homepageComponents ?
												newSettings.kbModule.homepageComponents :
												this.state.homepageComponents;

			this.setState({ homepageComponents });
		}
		const widgetMessage: WidgetMessage = event.data.__ansWidget;
		if (widgetMessage) {
			switch (widgetMessage.type) {
				case WidgetMessageType.SET_CUSTOM_HOME_PAGE:
					const cleanHtml = sanitizeExceptWidgetSdk(widgetMessage.data.homePageHtml);
					this.setState({customHomePage: cleanHtml});
					break;
				default:
					break;
			}
		}
	}

	componentWillMount () {
		this.setState({ homepageComponents: this.props.baseConfig.widgetConfig.kbModuleSettings.homepageComponents });
	}

	sortArticles (articleA: Article, articleB: Article) {
		const articleIds = this.props.baseConfig.widgetConfig.kbModuleSettings.articleIds;
		if (articleIds.indexOf(articleA.id) < articleIds.indexOf(articleB.id)) {
			return -1;
		} else if (articleIds.indexOf(articleA.id) > articleIds.indexOf(articleB.id)) {
			return 1;
		} else {
			return 0;
		}
	}

	render () {
		const translate = this.props.baseConfig.translate;
		const allCategoryTree = this.props.baseConfig.categoryTree;
		const categoryTree = (allCategoryTree.length === 1 && allCategoryTree[0].children.length) ?
										allCategoryTree[0].children : allCategoryTree;

		const articles = this.props.articles.sort(this.sortArticles.bind(this));

		const categoriesList = categoryTree ? (
			<div className='home-categories-list'>
				<h3>{translate('widget-ng.home.topics-title')}</h3>
				<CategoryList
					categories={categoryTree}
					goToState={this.props.baseConfig.widgetNavigator.goToState}
					logger={this.props.baseConfig.logger}
				/>
			</div>
		) : null;

		const articlesComp = articles ? (
			<div className='home-articles'>
				<h3>{translate('widget-ng.home.featured-title')}</h3>
				<ArticleList articles={articles} goToState={this.props.baseConfig.widgetNavigator.goToState} withIcons={true} />
			</div>
		) : null;

		const homepageComponents = this.state.homepageComponents;

		const firstSettingsComponent = homepageComponents[0];
		const secondSettingsComponent = homepageComponents[1];

		const firstComponent = firstSettingsComponent.type === HomepageComponentTypes.CATEGORIES ?
										categoriesList : articlesComp;
		const secondComponent = secondSettingsComponent.type === HomepageComponentTypes.CATEGORIES ?
										categoriesList : articlesComp;

		const isFirstComponentEnabled = firstComponent && firstSettingsComponent.enabled;
		const isSecondComponentEnabled = secondComponent && secondSettingsComponent.enabled;

		const homePage = (
			<div className='home-page kb-page'>
				{this.props.children}
				{isFirstComponentEnabled ? firstComponent : null}
				{isFirstComponentEnabled && isSecondComponentEnabled ? (<hr/>) : null}
				{isSecondComponentEnabled ? secondComponent : null}
			</div>
		);
		const {customHomePage} = this.state;

		return (
			customHomePage ? <div className='custom-home-page' dangerouslySetInnerHTML={{__html: customHomePage}}/> : homePage
		);
	}
}
